// ChartGlassPanel.jsx
// A reusable minimalist glass panel for chart containers

export default function ChartGlassPanel({ title, children }) {
  return (
    <div className="dark:bg-blue-900 border dark:border-blue-800 rounded-lg shadow-lg p-6">
      {title && (
        <h2 className="text-lg font-semibold mb-4 text-blue-900 dark:text-blue-200">{title}</h2>
      )}
      {children}
    </div>
  );
}
